import { useState } from "react";
import { signInWithEmailAndPassword } from "firebase/auth";
import { auth } from "../firebase/firebase";
import { useNavigate } from "react-router-dom";

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      await signInWithEmailAndPassword(auth, email, password);
      navigate("/runtime");
    } catch (err: any) {
      setError(err.message);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-charcoal px-4">
      <form
        onSubmit={handleLogin}
        className="bg-secondary border border-darkgray rounded-xl p-8 w-full max-w-sm shadow-sm"
      >
        <h2 className="text-2xl font-semibold mb-6 text-offwhite">Log In</h2>
        {error && <p className="text-red-400 text-sm mb-4">{error}</p>}
        <input
          type="email"
          placeholder="Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className="w-full p-3 mb-4 border border-darkgray rounded-lg bg-charcoal text-offwhite focus:outline-none focus:ring-2 focus:ring-teal/30 transition"
          required
        />
        <input
          type="password"
          placeholder="Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          className="w-full p-3 mb-4 border border-darkgray rounded-lg bg-charcoal text-offwhite focus:outline-none focus:ring-2 focus:ring-teal/30 transition"
          required
        />
        <button
          type="submit"
          className="w-full bg-teal text-offwhite py-2 rounded-lg hover:bg-teal/80 transition"
        >
          Log In
        </button>
      </form>
    </div>
  );
}
